import { render, staticRenderFns } from "./RejectedTable.vue?vue&type=template&id=6fab953f"
import script from "./RejectedTable.vue?vue&type=script&lang=js"
export * from "./RejectedTable.vue?vue&type=script&lang=js"
import style0 from "./RejectedTable.vue?vue&type=style&index=0&id=6fab953f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports